import jsCookie from "js-cookie";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { API_BASE } from "config/api";
import { RegForm } from "./RegForm";
import { AuthForm } from "./AuthForm";
import { RegCodeForm } from "./RegCodeForm";

import styles from "./RegistrationPage.module.scss";

export const RegistrationPage: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  // const [debugCode, setdebugCode] = useState("");
  // const [userName, setUserName] = useState<string>("");
  const [step, setStep] = useState<"reg" | "auth" | "regCode">("auth");
  const [sourcePage, setSourcePage] = useState<"auth" | "reg">("auth");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [serverError, setServerError] = useState<string | null>(null);

  // Проверка существования email
  const checkEmailExists = async (email: string) => {
    try {
      console.log("Проверка email, отправляем:", { email });
      const response = await fetch(`${API_BASE}/users/signin/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      console.log("полный ответ сервера:", response);
      const result = await response.json();

      if (response.status === 404) {
        console.log("Email не найден, регистрируем нового пользователя");
        setSourcePage("reg");
        setStep("reg");
      } else if (response.ok) {
        console.log("Email найден, отправляем код подтверждения", response);
        console.log(result);

        // setdebugCode(result["debug_code"]);
        setSourcePage("auth");
        setStep("regCode");
      }
    } catch (err) {
      console.error("Ошибка при проверке почты", err);
    }
  };
  // Обработка регистрации
  const handleRegistration = async (name: string, agreement: boolean) => {
    try {
      console.log("Регистрируем пользователя:", { email, name, agreement });

      const response = await fetch(`${API_BASE}/users/signup/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          first_name: name,
          consent_personal_data: agreement,
        }),
      });
      const result = await response.json();
      if (response.ok) {
        // setdebugCode(result["debug_code"]);
        setStep("regCode");
        setServerError(null);
      } else {
        const errorMessage =
          result.email?.[0] || "Сетевая ошибка, попробуйте позже.";
        setServerError(errorMessage);
      }
    } catch (err) {
      setServerError("Сетевая ошибка");
      console.error("Ошибка при регистрации", err);
    }
  };

  // Подтверждение кода
const verifyCode = async (email: string, code: string) => {
  try {
    const response = await fetch(`${API_BASE}/users/auth/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, checking_code: code }),
      credentials: "include",
    });

    const text = await response.text();
    const data = text ? JSON.parse(text) : null;

    if (!response.ok || !data?.access) {
      throw new Error(data?.message || "Неверный код подтверждения");
    }

    jsCookie.set("authToken", data.access, {
      path: "/",
      expires: 30,
      sameSite: "Lax"
    });
    localStorage.setItem("userId", data.user.id.toString());
    localStorage.setItem("userEmail", data.user.email);
    localStorage.setItem("userName", data.user.first_name);

    if (sourcePage === "reg") {
      navigate("/accountPage");
    } else {
      navigate("/");
    }
  } catch (err) {
    if (err instanceof Error) {
      console.error("verifyCode error:", err.message);
      throw err;
    }

    throw err;
  }
};

  // Логика для повторной отправки кода при регистрации
  const handleResendCode = async () => {
    try {
      if (sourcePage === "auth") {
        await checkEmailExists(email);
      } else {
        const response = await fetch(`${API_BASE}/users/signin/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });
        if (!response.ok) throw new Error("Ошибка отправки кода");
      }
    } catch (err) {
      console.error("Ошибка при повторной отправке:", err);
      setError("Не удалось отправить код");
    }
  };

  return (
    <div className={styles.wrapp}>
      <section className={styles.formWrapp}>
        {step === "regCode" ? (
          <RegCodeForm
            email={email}
            error={error}
            onCodeSubmit={async (code) => {
              await verifyCode(email, code);
            }}
            sourcePage={sourcePage}
            onResendCode={handleResendCode}
          />
        ) : step === "auth" ? (
          <AuthForm
            onValidSubmit={(email) => {
              setEmail(email);
              checkEmailExists(email);
            }}
            onSwitchToReg={() => setStep("reg")}
          />
        ) : (
          <RegForm
            onValidSubmit={(name, agreement) => {
              // setUserName(name);
              handleRegistration(name, agreement);
            }}
            serverError={serverError}
          />
        )}
      </section>
    </div>
  );
};
